<template>
  <div id="rePayPassword">
    <mt-header fixed :title="$t('验证您的身份')">
      <mt-button icon="back" slot="left" @click.native="$router.back()"></mt-button>
    </mt-header>
    <div class="container">
      <div class="swiper">
        <p class="wx_fontSize3" style="text-align:center">{{ $t('请输入验证码') }}</p>
      </div>
      <div class="passContainer">
        <Password v-on:end="onEnd"></Password>
      </div>
      <div style="padding: 15px;" class="dl_font12">
        {{ $t('没有收到验证码？') }}
        <Code @click.native="sendCode" ref="code"></Code>
      </div>
    </div>
    <ImageVerify scene="open_google_auth" :username="mobile" ref="imageverify" @imageCallback="imageCallback">
    </ImageVerify>
  </div>
</template>

<script>
import { Toast } from "mint-ui";
import Password from "@/components/Password";
import ImageVerify from "@/components/ImageVerify.vue";
import { httpSendMobileCode } from "@/api/login";
import { httpCheckPayPassword, httpCheckMesCode } from "@/api/userCenter";
import Code from "@/components/Code";
export default {
  components: { Toast, Password, Code, ImageVerify },
  data() {
    return {
      mobile: this.$store.state.userInfo.mobile ? this.$store.state.userInfo.mobile : this.$store.state.userInfo.user_email,
    };
  },
  methods: {
    onEnd: function (val) {
      const p = {
        vcode: val,
        type: this.$store.state.userInfo.mobile ? 'mobile' : 'email'
      };
      httpCheckMesCode(p)
        .then(res => {
          this.$router.replace('/googleCode?code=' + val)
        })
        .catch(() => { });

    },
    sendCode: function () {
      // const p = {
      //   username: this.mobile,
      //   scene: 'open_google_auth'
      // };
      // httpSendMobileCode(p)
      //   .then(res => {
      //     Toast(res.msg);
      //     this.$refs.code.run();
      //   })
      //   .catch(() => { });
      // 图片验证
      this.$refs.imageverify.run()
    },
    imageCallback() {

      this.$refs.code.run();
    },
  },
  mounted() { },
  activated: function () {
    this.sendCode();
  },
};
</script>

<style scoped>
#rePayPassword {
  width: 100%;
}

.mint-header {
  background: #ffffff;
  color: #212529;
  border-bottom: 1px solid #e3e8ed;
}

.mint-button--default {
  color: #656b79 !important;
}

.container {
  padding: 50px 10px 10px 10px;
}

.swiper {
  background-color: #fff;
  box-sizing: border-box;
  border-radius: 10px;
  color: #4a4a4a;
  padding: 10px;
  box-sizing: border-box;
  margin-top: 20px;
}

.swiper p {
  margin: 5px;
}
</style>
